<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchInvoicePayoffAccount">
                    <input v-model="search.account"
                            class="form-control mr-sm-2"
                            type="text"
                            placeholder="รหัสบัญชี"/>
                    <button @click="searchInvoicePayoffAccount"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp
                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="addInvoicePayoffAccount"
                            type="button">
                        <icon name="plus"></icon>
                        เพิ่มรหัสบัญชี
                    </button>&nbsp
                </form>
            </div>
        </nav>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รหัสบัญชี</th>
                    <th scope="col">รายการ</th>
                    <th scope="col" width="150px">แก้ไข</th>
                    <th scope="col">ลบ</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(data,index) in account_list">
                    <tr>
                        <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                        <td>{{data.account}}</td>
                        <td>{{data.name}}</td>
                        <td>
                            <button class="btn btn-primary" @click="showInvoicePayoffAccount(data.id)">
                                <icon name="pencil-alt"></icon>
                                แก้ไข
                            </button>
                        </td>
                        <td>
                            <button class="btn btn-danger" @click="showDeleteModal(data.id)">
                                <icon name="trash-alt"></icon>
                                ลบ
                            </button>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
            <vue-pagination :pagination="dataPaginate" @paginate="getPage">
            </vue-pagination>
        </div>
        <!--modal account-->
        <b-modal hide-header hide-footer ref="add_account">
            <div class="text-center">
                <add-account-modal account_menu="income" @submit="saveAccount">
                </add-account-modal>
            </div>
        </b-modal>
        <!--modal delete-->
        <b-modal hide-header hide-footer ref="delete_item">
           <delete-confirm-modal @submit="deleteData"></delete-confirm-modal>
        </b-modal>
        <!--modal loading-->
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import AddAccountModal from "../BillingPayment/AddAccountModal";
    import VuePagination from "../../Pagination";
    import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
    import Loading from "../../Utility/Loading";
    export default {
        components: {
            Loading,
            DeleteConfirmModal,
            VuePagination,
            AddAccountModal},
        name: "invoice-payoff-account",
        data(){
            return{
                page : 1,
                status_loading : 1,
                msg : '',
                delete_id : '',
                search : {
                    account : ""
                },
                event_submit : ""
            }
        },
        created(){
            this.getInvoicePayoffAccount();
        },
        computed:{
            ...mapState({
                account_list : state=>{
                    return state.Account.paymentAccountTable;
                },
                dataPaginate : state=>{
                    return state.Account.dataPaginate;
                },
                form : state=>{
                    return state.Account.paymentAccountForm
                },
            })
        },
        methods:{
            showAddAccountModal() {
                this.$refs.add_account.show();
            },
            hideAddAccountModal() {
                this.$refs.add_account.hide();
            },
            showDeleteModal(id) {
                this.delete_id = id;
                this.$refs.delete_item.show();
            },
            hideDeleteModal() {
                this.$refs.delete_item.hide();
            },
            showLoadingModal() {
                this.$refs.loading.show();
            },
            hideLoadingModal() {
                this.$refs.loading.hide();
            },
            addInvoicePayoffAccount(){
                this.$store.dispatch("Account/clearData",'income').then(()=>{
                    this.showAddAccountModal();
                    this.$store.dispatch("Account/generatePaymentAccountNumber",4).then(res=>{
                        this.form.account = res;
                    })
                });
            },
            saveAccount(submit){
                if(submit){
                    this.$store.dispatch("Account/saveInvoicePayoffAccount",{
                        id : submit.id,
                        data : submit
                    }).then(()=>{
                        this.getInvoicePayoffAccount();
                    })
                }
                this.hideAddAccountModal();
            },
            showInvoicePayoffAccount(id){
                this.$store.dispatch("Account/showInvoicePayoffAccount",id).then(()=>{
                    this.showAddAccountModal();
                });
            },
            getInvoicePayoffAccount(){
                let data = {
                    account : ""
                };
                this.$store.dispatch("Account/getInvoicePayoffAccount",{
                    page : this.page,
                    data : data
                });
            },
            deleteData(value){
                if(value){
                    this.$store.dispatch("Account/deleteInvoicePayoffAccount",this.delete_id).then(()=>{
                        this.hideDeleteModal();
                        this.showLoadingModal();
                        this.msg = 'ลบข้อมูลสำเร็จ';
                        this.status_loading = 2;
                        this.getInvoicePayoffAccount();
                    }).catch(()=>{
                        this.showLoadingModal();
                        this.msg = 'ลบข้อมูลไม่สำเร็จ';
                        this.status_loading = 3;
                    })
                }else{
                    this.hideDeleteModal();
                }

            },
            searchInvoicePayoffAccount(){
                this.event_submit = true;
                let data = {
                    account : this.search.account
                };
                this.$store.dispatch("Account/getInvoicePayoffAccount",{
                    page : this.page,
                    data : data
                });
            },
            getPage(){
                this.page = this.dataPaginate.current_page;
                if(this.event_submit){
                    this.searchInvoicePayoffAccount();
                }
                else{
                    this.getInvoicePayoffAccount();
                }
            }
        },

    }
</script>

<style scoped>

</style>
